import { stands } from "../misc/client";
import GenericCRUD from "./GenericCRUD";

export const AdminStands = () => (
  <GenericCRUD
    title="Stand"
    canCreate={true}
    api={stands}
    columns={[
      { key: "stand_number", label: "Stand Number" },
      { key: "stand_type", label: "Type" },
      { key: "max_weight_kg", label: "Max Weight (kg)" },
      { key: "hourly_rate_light", label: "Light Rate/Hr" },
      { key: "hourly_rate_heavy", label: "Heavy Rate/Hr" },
      { key: "status", label: "Status" },
    ]}
    formFields={[
      {
        key: "stand_number",
        label: "Stand Number",
        type: "text",
        placeholder: "A1, B2, etc.",
        required: true,
        transform: (value) => value.toUpperCase(), // Auto-uppercase
      },
      {
        key: "stand_type",
        label: "Stand Type",
        type: "select",
        options: [
          { value: "light_aircraft", label: "Light Aircraft" },
          { value: "heavy_aircraft", label: "Heavy Aircraft" },
        ],
        required: true,
        defaultValue: "light_aircraft",
      },
      {
        key: "max_weight_kg",
        label: "Max Weight (kg)",
        type: "number",
        defaultValue: 2000,
        min: 0,
        step: 100,
      },
      {
        key: "description",
        label: "Description",
        type: "textarea",
        placeholder: "Optional description of the stand",
      },

      // Light Aircraft Rates Section
      {
        key: "section_light",
        label: "Light Aircraft Rates (€)",
        type: "section", // If GenericCRUD supports sections
      },
      {
        key: "hourly_rate_light",
        label: "Hourly Rate",
        type: "number",
        precision: 2,
        step: 0.5,
        defaultValue: 5.0,
        min: 0,
      },
      {
        key: "daily_rate_light",
        label: "Daily Rate",
        type: "number",
        precision: 2,
        step: 5,
        defaultValue: 50.0,
        min: 0,
      },
      {
        key: "monthly_rate_light",
        label: "Monthly Rate",
        type: "number",
        precision: 2,
        step: 10,
        defaultValue: 300.0,
        min: 0,
      },

      // Heavy Aircraft Rates Section
      {
        key: "section_heavy",
        label: "Heavy Aircraft Rates (€)",
        type: "section", // If GenericCRUD supports sections
      },
      {
        key: "hourly_rate_heavy",
        label: "Hourly Rate",
        type: "number",
        precision: 2,
        step: 0.5,
        defaultValue: 8.0,
        min: 0,
      },
      {
        key: "daily_rate_heavy",
        label: "Daily Rate",
        type: "number",
        precision: 2,
        step: 5,
        defaultValue: 80.0,
        min: 0,
      },
      {
        key: "monthly_rate_heavy",
        label: "Monthly Rate",
        type: "number",
        precision: 2,
        step: 10,
        defaultValue: 500.0,
        min: 0,
      },

      {
        key: "status",
        label: "Status",
        type: "select",
        options: [
          { value: "active", label: "Active" },
          { value: "maintenance", label: "Maintenance" },
          { value: "disabled", label: "Disabled" },
        ],
        defaultValue: "active",
        required: true,
      },
    ]}
    // Optional: Custom validation
    validate={(data) => {
      const errors = {};

      if (!data.stand_number?.trim()) {
        errors.stand_number = "Stand number is required";
      }

      if (data.hourly_rate_light < 0) {
        errors.hourly_rate_light = "Rate cannot be negative";
      }

      if (data.hourly_rate_heavy < 0) {
        errors.hourly_rate_heavy = "Rate cannot be negative";
      }

      return Object.keys(errors).length > 0 ? errors : null;
    }}
    formatters={{
      stand_type: (value) => value?.replace("_", " "),
      hourly_rate_light: (value) => `€${value}`,
      hourly_rate_heavy: (value) => `€${value}`,
      status: (value) => value?.charAt(0).toUpperCase() + value?.slice(1),
    }}
    formLayout={{
      grid: true,
      columns: {
        stand_number: { span: 6 },
        stand_type: { span: 6 },
        max_weight_kg: { span: 6 },
        status: { span: 6 },
        description: { span: 12 },
        hourly_rate_light: { span: 4 },
        daily_rate_light: { span: 4 },
        monthly_rate_light: { span: 4 },
        hourly_rate_heavy: { span: 4 },
        daily_rate_heavy: { span: 4 },
        monthly_rate_heavy: { span: 4 },
      },
    }}
    // Optional: Custom modal size
    modalSize="lg"
    // Optional: Custom row actions
    customActions={[
      {
        label: "View Details",
        icon: "eye",
        action: (item) => console.log("View stand details:", item),
        color: "blue",
      },
      {
        label: "Maintenance Mode",
        icon: "settings",
        action: (item) => {
          // Toggle maintenance mode
          const newStatus =
            item.status === "maintenance" ? "active" : "maintenance";
          stands.update(item.stand_id, { ...item, status: newStatus });
        },
        condition: (item) => item.status !== "disabled",
        color: "orange",
      },
    ]}
  />
);
